@if (valueRounded === undefined) {
  <div class="no-known-price extra-info">
    No known price
  </div>
} @else if (rtl) {
  @if (divineValueRounded) {
    @if (showPreviousValue) { <span class="extra-info">{{ previousDivineValueRounded }} → </span> } {{ divineValueRounded }} <img class="base-type-image inline-image" [src]="divineImage" />
  } @else if (valueRounded) {
    @if (showPreviousValue) { <span class="extra-info">{{ previousValueRounded }} → </span> } {{ valueRounded }} <img class="base-type-image inline-image" [src]="basicImage" />
  }
} @else {
  @if (divineValueRounded) {
    <img class="base-type-image inline-image" [src]="divineImage" /> @if (showPreviousValue) { <span class="extra-info">{{ previousDivineValueRounded }} → </span> } {{ divineValueRounded }}
  } @else if (valueRounded) {
    <img class="base-type-image inline-image" [src]="basicImage" /> @if (showPreviousValue) { <span class="extra-info">{{ previousValueRounded }} → </span> } {{ valueRounded }}
  }
}

@if (!hideExtraInfo && extraInfoText) {
  <span [class]="newValue ? 'new-value' : 'uncertain-value'">({{ extraInfoText }})</span>
}
